import { Breakpoint } from "@mui/material/styles";
import classNames from "classnames";

import { Dialog } from "components/Dialog/Dialog";
import LoadingOverlap from "components/LoadingOverlap";

import styles from "./styles.module.scss";

type Props = {
  title: string;
  header?: React.ReactNode;
  size?: string;
  maxWidth?: Breakpoint;
};

export const SkeletonWizard = (props: Props) => {
  const { title, header, size, maxWidth } = props;

  return (
    <Dialog
      fullWidth
      maxWidth={maxWidth}
      size={size}
      open
    >
      <div className={classNames(styles.wrapper, size && styles[size])}>
        <div className={styles.header}>
          <div className={styles.header__items}>
            <div className={styles.header__inner}>
              <div className={styles.header__title}>{title}</div>
            </div>
            {header}
          </div>
        </div>
        <div className={styles.body}>
          <LoadingOverlap isLoading />
        </div>
      </div>
    </Dialog>
  );
};
